var map = {
	"./arrow_back.png": 1307,
	"./arrow_next.png": 2163,
	"./chbtn.png": 6941,
	"./chbtn2.png": 6135,
	"./css/epg.scss": 2354,
	"./css/player.css": 1272,
	"./info.png": 9548,
	"./man.jpg": 7727,
	"./oneplay.png": 1609,
	"./oneplay_mobile.png": 4595,
	"./oneplay_peru.png": 1439,
	"./oneplay_peru_mobile.png": 4234,
	"./tv.png": 424,
	"./user1.png": 9153,
	"./vocex.png": 5954,
	"./vocex_mobile.png": 9330
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;